import _sfc_main from "./component-library82.mjs";
import "./component-library83.mjs";
import normalizeComponent from "./component-library81.mjs";
var _sfc_render = function render() {
  var _vm = this, _c = _vm._self._c, _setup = _vm._self._setupProxy;
  return _c(_setup.component, { tag: "component", staticClass: "arrow", class: `arrow--${_vm.direction} ${_vm.setPosition ? "arrow--set-position" : ""}`, attrs: { "no-styling": "", "tag": _vm.tag, "type": _setup.isLink ? "button" : void 0 }, on: { "click": function($event) {
    return _vm.$emit("change", _vm.direction);
  } } });
};
var _sfc_staticRenderFns = [];
var __component__ = /* @__PURE__ */ normalizeComponent(
  _sfc_main,
  _sfc_render,
  _sfc_staticRenderFns,
  false,
  null,
  "1dbffa0e",
  null,
  null
);
const Arrow = __component__.exports;
export {
  Arrow as default
};
